import { api } from '@/api';
import { TaskTypeDescription, QaRtSystemTemplateContainerDto } from '@/api/generator';

export const loadQaRtSystemTemplateContainers = async (
  taskType: TaskTypeDescription,
  onSuccess: (containers: QaRtSystemTemplateContainerDto[]) => void,
  ids: Array<string> = [],
) => {
  const { result, success } = await api.taskItemsApi.getTaskItemQaRtSystemTemplate({
    getQaRtSystemTemplateDto: {
      taskType,
      supportSystemEntityIds: ids,
    },
  });
  if (success) {
    onSuccess(result.containers || []);
  }
};
